import * as React from "react";
import {
  Box,
  Chip, CircularProgress,
  Grid,
  Typography,
} from "@mui/material";
import {Inventory2Outlined, UnarchiveOutlined} from "@mui/icons-material";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import {CustomTabPanel} from "../../../utils/custom-tab-panel";
import BackButton from "../../../components/button/back-button.component";
import {useParams} from "react-router-dom";
import {useEffect, useState} from "react";
import MountJigaComponent from "./mount-jiga.component";
import MountRmaComponent from "./mount-rma.component";
import {FtBomService} from "../../../services/ft-bom-service";
import {ErrorComponent} from "../../../components/error/error.component";
import {translate} from "../../../translate/translate";
import {useAuth} from "../../../contexts/auth-context";
import {Profile} from "../../../models/account/user";

const MountJigaRmaComponent = () => {
    const { user } = useAuth();
    const hasPermission = user?.perfil === Profile.ADMIN || user?.perfil === Profile.OPERACIONAL;

    const [tab, setTab] = React.useState(0);
    const params = useParams();
    const ftbom = params.ftbom;
    const idClient = params.idClient;
    const [doneMount, setDoneMount] = useState(false);
    const [active, setActive] = useState(true);
    const [loading, setLoading] = useState(false);
    const service = new FtBomService();

    useEffect(() => {
        loadStatus();
    }, []);

    const loadStatus = (initialize = true) => {
        if (idClient && ftbom) {
            setLoading(true);
            service.get_status_mount(idClient, ftbom).then((response) => {
                setDoneMount(response.data.status_mount)
                setActive(response.data.active)
            }).catch((error: any) => {
                ErrorComponent(error);
            }).finally(() => {
                setLoading(false);
            });
        }
    }

    const handleChangeTab = (event: React.SyntheticEvent, newValue: number) => {
        setTab(newValue);
        loadStatus();
    };

    const mountStatus = () => {
        if (doneMount && !loading) {
            return (
                <Chip size="small"
                      color="success"
                      label="Concluída"
                />
            );
        }
        if (!doneMount && !loading) {
            return (
                <Chip size="small"
                      color="warning"
                      label="Pendente"
                />
            );
        }
        if (loading)  {
          return <CircularProgress size="10px" />
        }
    }

    return (
        <section>
            <div className="floating-title" style={{display: "flex", flexDirection: "row", alignItems: "center"}}>
                <BackButton url={'/reports/ftb-general'} />
                <Typography variant={"h5"}>
                    {ftbom}
                </Typography>
            </div>

            <div className="floating-button" style={{display: "flex", flexDirection: "row", alignItems: "center", gap: "10px"}}>
                <p className="text">Status JIGA/RMA: {mountStatus()}</p>
                <p className="text">
                    Status: {!loading ? (active ? translate.t('active') : translate.t('inactive')) : '-'}
                </p>
            </div>

            <Box bgcolor="white" margin="1rem auto" pb={1} pt={1}>
                <Box sx={{
                    borderBottom: 1,
                    borderColor: 'divider',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    paddinTop: '20px',
                }}>
                    <Grid>
                        <Tabs value={tab}
                              onChange={handleChangeTab}>
                            <Tab label={
                                <Grid display="flex" alignItems="center" gap="10px" color="secondary">
                                    <Inventory2Outlined/>MONTAGEM DE JIGA
                                </Grid>
                            } />
                            <Tab label={
                                <Grid display="flex" alignItems="center" gap="10px" color="secondary">
                                    <UnarchiveOutlined/>RMA
                                </Grid>
                            } />
                        </Tabs>
                    </Grid>
                </Box>
                <CustomTabPanel value={tab} index={0}>
                    <MountJigaComponent
                        hasPermission={hasPermission}
                        doneMount={(done: boolean) => setDoneMount(done)}
                        changeActive={(active: boolean) => setActive(active)}
                    />
                </CustomTabPanel>
                <CustomTabPanel value={tab} index={1}>
                    <MountRmaComponent
                        hasPermission={hasPermission}
                        doneMount={(done: boolean) =>  setDoneMount(done)}
                        changeActive={(active: boolean) => setActive(active)}
                    />
                </CustomTabPanel>
            </Box>
        </section>
    );
};

export default MountJigaRmaComponent;
